<form [formGroup]="formGroup"
      class="single-value-editor">
    <ui-value-type #assetValue
                   [readonlyCredential]="readonly"
                   [type]="type"
                   [scope]="AssetScope.Global"
                   [disabled]="disabled"
                   [valuePlaceholder]="typeLabel"
                   [externalNamePlaceholder]="'assets_modal_form_external_name' | translate"
                   [externalNamePlaceholderName]="externalName"
                   [usernamePlaceholder]="'assets_modal_form_username' | translate"
                   [passwordPlaceholder]="'assets_modal_form_password' | translate"
                   [truePlaceholder]="'assets_modal_form_bool_true' | translate"
                   [falsePlaceholder]="'assets_modal_form_bool_false' | translate"
                   [tooltipShow]="'password_toggle_show' | translate"
                   [tooltipHide]="'password_toggle_hide' | translate"
                   [form]="formGroup"
                   formControlName="value"
                   data-cy="asset-value">
        <ui-value-primary-hints [form]="formGroup"
                                name="value"
                                hint-primary>
        </ui-value-primary-hints>
        <ui-value-secondary-hints [form]="formGroup"
                                  name="value"
                                  hint-secondary>
        </ui-value-secondary-hints>
    </ui-value-type>
    <ng-container *ngIf="valueHintEnabled">
        <mat-hint *ngIf="!formGroup.get('value')?.errors && !formGroup.errors ||
                    (formGroup.get('value')?.hasError('required') &&
                    !formGroup.hasError('invalidPassword'))"
                  class="global-value-hint">
            {{ 'assets_modal_form_value_hint' | translate }}
        </mat-hint>
    </ng-container>
</form>
